module.exports = __webpack_public_path__ + "static/media/Legs-&-Abs-2.03ccdb6d.jpeg";